import React, { Component } from 'react';

export default class Solution extends Component {
    render() {
        return (
            <div className="Solution">
                <p>Contributors: Royce Le, Cindy Nguyen, Aindra Thin, Maxwell Zhou</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Solution.js